import React from "react";
import "./modal.css";
import { Modal } from "react-bootstrap";
import rightArrow from "../../../images/rightArrow.svg";
import cross from "../../../images/union.png";
const Ucmodal = ({
  heading,
  description,
  keyPoints,
  imageURL,
  setShowModal,
  isMobile,
}) => {
  return (
    <div>
      <Modal
        contentClassName="headingOfModal"
        show={true}
        size="lg"
        onHide={() => setShowModal(isMobile ? true : false)}
      >
        <img src={imageURL} className="modal-image" alt="" />
        <Modal.Body>
          <div className={"modal-close"} onClick={() => setShowModal(false)}>
            <img src={cross} />
          </div>
          <div className="culture-modal-body">
            <div className="culture-modal-heading">{heading}</div>
            <div className="culture-modal-content">{description}</div>
            <div className="top-3-behaviours">
              Top 3 behaviours to exhibit this value in day-to-day work:
            </div>
            {keyPoints.map((point) => {
              return (
                <div className="list-of-culture-behaviour">
                  <img
                    src={
                      isMobile
                        ? rightArrow
                        : "https://res.cloudinary.com/urbanclap/image/upload/images-stage/supply/test-upload-use-case/1625227952155-f5e276.png"
                    }
                    className={"right-arrow"}
                  />

                  <lablel className="list-of-culture-behaviour-label">
                    {point}
                  </lablel>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Ucmodal;
